import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Blok } from '../../../../interfaces/Blok.interface';
import { getSavingsNotice } from '../../../../store/slices/quote/quote.store';
import QuoteSavingsNotice from '../QuoteSavingsNotice/QuoteSavingsNotice';
import QuoteButtonsBar from './QuoteButtonsBar';
import QuoteTotalBar from './QuoteTotalBar';
import { QuoteContext } from '../../../../contexts/Quote';

interface QuoteTotalAndButtonsBlokProps extends Blok {
  total_label: string;
  show_savings_box?: boolean;
  primary_cta: Blok[];
  secondary_cta: Blok[];
}

interface QuoteTotalAndButtonsProps {
  blok: QuoteTotalAndButtonsBlokProps;
}

const QuoteTotalAndButtons: React.FC<QuoteTotalAndButtonsProps> = ({
  blok,
}) => {
  const {
    total_label,
    primary_cta,
    secondary_cta,
    show_savings_box = false,
  } = blok;

  const { quoteCostBreakdown } = useContext(QuoteContext);

  const savingsNotice =
    quoteCostBreakdown?.costBreakdown.conveyancingBreakdown.savingsNotice;

  return (
    <section>
      {show_savings_box && savingsNotice && (
        <QuoteSavingsNotice savingsNotice={savingsNotice} />
      )}
      <QuoteTotalBar total_label={total_label} />
      <QuoteButtonsBar
        primary_cta={primary_cta}
        secondary_cta={secondary_cta}
      />
    </section>
  );
};

export default memo(QuoteTotalAndButtons);
